import type { UseDateTimeTextFormatterArgs } from '../../hooks';
import { useDateTimeTextFormatter } from '../../hooks';

export interface DateRangeTextProps extends UseDateTimeTextFormatterArgs {
  startDate: number | string | Date;
  endDate?: number | string | Date | null;
}

export function DateRangeText({ startDate, endDate, showTime = true, ...props }: DateRangeTextProps) {
  const dateFormatter = useDateTimeTextFormatter({
    showTime,
    ...props,
  });

  return <span>{dateFormatter.formatRange(new Date(startDate), new Date(endDate ?? startDate))}</span>;
}
